import { Component } from '@angular/core';
import { PgFormField, PgFormLayout } from '../../../models/form.model';
import { SingleFormComponent } from '../single-form-main';

@Component({
    selector: 'app-forms-checkin-point',
    templateUrl: './forms-checkin-point.component.html',
    styleUrls: ['./forms-checkin-point.component.scss'],
    standalone: false
})
export class FormsCheckinPointComponent extends SingleFormComponent {

    resourceId = 'CheckinPoint';

    formLayout = new PgFormLayout([
        new PgFormField({ label: 'auto', type: 'string', name: 'code', required: true }),
        new PgFormField({ label: 'auto', type: 'string', name: 'name', required: true }),
        new PgFormField({ label: 'auto', type: 'html', name: 'description', locale: true }),
        new PgFormField({ label: 'auto', type: 'select', name: 'realm_id' }),
    ]);

    availableLanguages:Array<string> = null;

    protected async afterInitializeForm() {
        this.availableLanguages = this.localizationService.availableApplicationLanguages;

        this.formLayout.getFieldByName('realm_id').visible = false;
    }
}

